app.service('configService', ['$http', '$rootScope', '$q', function ($http, $rootScope, $q) {
    var that = this;

    // multiple controllers will request the config option simultaneously
    // so save the first request as a promise to prevent multiple web request
    var configPromise = null;

    that.getConfig = function (success, error) {
        if ($rootScope.ptuConfig) {
            success({ data: $rootScope.ptuConfig });
        } else {
            if (!configPromise) {
                configPromise = $http.get('./api/PtuConfig')
                    .then(function (response) {
                        $rootScope.ptuConfig = response.data;
                        return response;
                    });
            }

            configPromise.then(success, error);
        }
    };
}]);